/* global axios */

import ApiClient from './ApiClient';

class AgentPauses extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  list() {
    return axios.get(`${this.baseUrl()}/agent_pauses`);
  }

  approve(id) {
    return axios.post(`${this.baseUrl()}/agent_pauses/${id}/approve`);
  }

  reject(id) {
    return axios.post(`${this.baseUrl()}/agent_pauses/${id}/reject`);
  }
}

export default new AgentPauses();
